if (!customElements.get('volume-pricing')) {
  class VolumePricing extends HTMLElement {
    constructor() {
      super();
      this.displayPriceDynamically = this.classList.contains('change-price');
      this.productInfo = this.closest('.product-info');
      this.volumePricing = window.volumePricing[this.dataset.productId];
      if (this.productInfo) {
        this.qtyInput = this.productInfo.querySelector('input[name="quantity"]');
        if (this.qtyInput && this.displayPriceDynamically && this.volumePricing) {
          this.qtyInput.addEventListener('change', this.updatePrice.bind(this));
        }
      }
    }

    updatePrice(event) {
      let quantity = event.target.value;
      let price = this.productInfo.querySelector('.price__current');
      if (price) {
        let newPrice = this.getPriceForQuantity(quantity);
        if (newPrice) {
          price.textContent = newPrice;
        }
      }
    }

    getPriceForQuantity(quantity) {
      // Sort the volume pricing array in descending order of minimum_quantity
      const sortedPricing = this.volumePricing.sort((a, b) => b.minimum_quantity - a.minimum_quantity);
      
      // Find the first price break that has a minimum quantity less than or equal to the given quantity
      const nearestPriceBreak = sortedPricing.find(price_break => price_break.minimum_quantity <= quantity);
      
      // Return the price of the nearest price break, or 0 if no matching price break is found
      return nearestPriceBreak ? nearestPriceBreak.price : 0;
    }
  }

  customElements.define('volume-pricing', VolumePricing);
}
